import { Controller } from "@hotwired/stimulus"

// stimulus controllers created for managing creation and disposing Bootstrap JS objects
//
// `data-toggle` attribute still required for bs js component to work (Data API)
//
// event listeners on set on `document` (Data API implementation)
// set when importing bs module, ex:
//   https://github.com/twbs/bootstrap/blob/v5.3.8/js/src/collapse.js#L280
//   https://github.com/twbs/bootstrap/blob/v5.3.8/js/src/tab.js#L285
// no need to manually trigger methods like: toggle(), show(), etc
export default class extends Controller {
  connect () {
    this.controlsEl = (
      this.element.ariaControlsElements || []
    )[0]
    this._setAttributes()
    this._bsComponent = this._createBsComponent()
  }

  disconnect () {
    this._bsComponent.dispose()
  }

  _setAttributes(componentName) {
    const el = this.element
    el.setAttribute("data-bs-toggle", componentName)
    if (this.controlsEl) {
      el.setAttribute("data-bs-target", `#${this.controlsEl.id}`)
    }
  }
}
